import * as Styles from '@screens/lp-default/components/team/components/tabs/styles';
import * as Tabs from '@radix-ui/react-tabs';
import { tabsAndContents } from '@screens/lp-default/components/team/constants';
import LandingPageTeam from '@screens/landing-page-team';
import { snowplowButtonClick } from '@analytics/snowplow/events';

export default function TeamTabs() {
  const handleTabClick = (tab: string) => {
    snowplowButtonClick('tab_selector', '/planos', tab, 'content_section');
  };

  return (
    <Styles.TabsRoot defaultValue={tabsAndContents[0].tab} data-testid="team-tabs">
      <Styles.TabsList>
        {tabsAndContents.map((tab) => (
          <Tabs.Trigger key={tab.tab} value={tab.tab} onClick={() => handleTabClick(tab.tab)}>
            <Styles.TabName>{tab.tab}</Styles.TabName>
          </Tabs.Trigger>
        ))}
      </Styles.TabsList>
      {tabsAndContents.map((tab) => (
        <Tabs.Content key={tab.tab} value={tab.tab} data-testid="team-tab-content">
          <LandingPageTeam screenData={tab} />
        </Tabs.Content>
      ))}
    </Styles.TabsRoot>
  );
}
